import React, { ReactElement } from 'react';
import { useGetLibraryElearningsQuery } from '@/modules/services/courseLibrary';
import { useHistory, useLocation } from 'react-router-dom';
import { getQueryString } from '@/lib/util';
import { CourseLibraryDefaultQueryString } from '@/pages/CourseLibrary/CourseLibraryRoutes';
import { useErrorHandler } from 'react-error-boundary';
import CourseLibraryView from '@/pages/CourseLibrary/CourseLibraryView';
import { useUserHasCapabilities } from '@/lib/auth/useUserHasCapabilities';
import { CourseLibraryPermissions } from '@/lib/auth/permissions/courseLibraryPermissions.enum';
import { Spinner } from 'elmo-elements';
import MyLibraryRoutes from '../MyLibrary/MyLibraryRoutes';
import { useGetCurrentTenantProfileQuery } from '@/modules/services';
import { useFlags } from 'launchdarkly-react-client-sdk';

const CourseLibrary = (): ReactElement => {
  const location = useLocation();
  const history = useHistory();
  const { learningElaNewCourseLibraryEnable: isElaCourseLibraryEnabled } =
    useFlags();
  // The legacy list is served by the old course builder; only call it when the
  // new course library is explicitly off, not while the flag is still loading.
  const { isError, error, isLoading } = useGetLibraryElearningsQuery(
    getQueryString(location.search, CourseLibraryDefaultQueryString),
    { skip: isElaCourseLibraryEnabled !== false },
  );
  const { data: tenantData, isLoading: tenantIsLoading } =
    useGetCurrentTenantProfileQuery();

  const courseLibraryEnabled =
    tenantData && +tenantData.configMetadata.enableCourseLibrary > 0;
  const canViewLibrary = useUserHasCapabilities([
    CourseLibraryPermissions.VIEW_COURSE_LIBRARY,
  ]);

  const handleError = useErrorHandler();

  if (isLoading || tenantIsLoading) {
    return <Spinner />;
  }

  if (
    (canViewLibrary !== undefined && !canViewLibrary) ||
    (courseLibraryEnabled !== undefined && !courseLibraryEnabled)
  ) {
    history.replace(MyLibraryRoutes.path);
    return <div />;
  }

  if (isError) {
    handleError(error);
    return <div />;
  }

  return <CourseLibraryView />;
};

export default CourseLibrary;
